import CallerIdSettingsDialog from "@/modules/callerId/views/CallerIdSettingsDialog.vue";

const routes = [
  {
    path: "/caller-id",
    name: "callerId",
    component: () => import(/* webpackChunkName: "CallerId" */ "./views/CallerId"),
    props: route => ({
      isCompatible: route.query.isCompatible === 'true',
      appName: route.query.appName.replace(/_/g, ' ')
    })
  },
  {
    path: "/caller-id-settings-dialog",
    name: "caller-id-settings-dialog",
    component: CallerIdSettingsDialog
  }
];

export default routes;
